import styled from "styled-components";
import { Paragraph, Heading } from "../../../atoms/Typography/Typography.styles";

export const ModalAuth = styled.div`
  position: relative;
  background-color: white;
  border-radius: ${({ theme }) => theme.rem(8)};
  padding: ${({ theme }) => theme.rem(32)};
`;

export const ModalAuthIconWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  margin: ${({ theme }) => theme.rem(16)};
  cursor: pointer;

  i {
    font-size: ${({ theme }) => theme.rem(24)};
  }
`

export const ModalAuthContent = styled.div`
  padding: ${({ theme }) => theme.rem(32)};

  ${Paragraph},
  ${Heading} {
    color: black;
  }
`